export { pushToDataLayer, sendEventToGTM } from './gtm';
